let content = {
    homepage_title: 'Contract Management Software | Create & Manage Contracts Faster',
    product_title: 'Product | Draft, Sign & Store Contracts | Contract Automation',
    use_cases_title: 'Use Cases | Contract Checklist Tool, Contract Management System',
    pricing_title: 'Pricing | Manage & Validate Contracts | Contract Software',
    faq_title: 'FAQs | Contract Management Made Easy | Contract Tool',
    contact_title: 'Contact us | Online Contract Portal',
    login_title: 'Login | Contract Management App',
    sign_up_title: 'Sign up for Free Trial | Create & Manage Contracts',
    careers_title: 'Career | Contract Automation Tool | Best Contract Management Software',
    integration_title: 'Integration | Contract Portal',
    term_condition_title: 'Terms & Conditions | Contract Management Software',
    privacy_policy_title: 'Privacy Policy | How we handle Contracts',
    client_portal_title: 'Client Portal - One single portal to sign Contracts & communicate',

    homepage_meta_desc: 'contract.docusafe.ai helps you draft, send, and manage contracts online. Create Sleeves, collaborate with clients, collect signatures, and store contracts securely or sync them into Cloud Apps.',
    product_meta_desc: 'Powerful features for creating and managing contracts. Draft a Sleeve, send to collaborators for signature, track status, and store securely. All-in-one Contract Management System.',
    use_cases_meta_desc: 'Explore how contract.docusafe.ai can be used by Lawyers, HR Managers, Auditors, Real Estate Agents, Financial Planners & Enterprises to create and manage contracts seamlessly.',
    pricing_meta_desc: 'Start with a free Sleeve. Pay only when your collaborator signs and uploads. Competitive pricing for contract management needs.',
    faq_meta_desc: 'Browse FAQs about creating, signing, and managing contracts. Contact our support team if your query isn’t listed.',
    contact_meta_desc: 'Contact us if you have any queries about contract.docusafe.ai Contract Software.',
    login_meta_desc: 'Login to contract.docusafe.ai to draft contracts, send for signature, and manage sleeves with approval & tracking system.',
    sign_up_meta_desc: 'Sign up for Free Trial. No credit card required. Start drafting and sending contracts instantly.',
    careers_meta_desc: 'Browse jobs and apply. We are looking for talented staff to build the future of contract management.',
    integration_meta_desc: 'We integrate continuously with cloud apps and platforms for a better contract experience.',
    term_condition_meta_desc: 'Review our Terms & Conditions before using contract.docusafe.ai Contract Platform.',
    privacy_policy_meta_desc: 'Read our Privacy Policy to understand how we store and protect your contract data.',

    homepage_meta_keyword: 'Contract Management, Draft Contracts, Collect Signatures',
    product_meta_keyword: 'Create contracts, Send contracts, Sign online',
    use_cases_meta_keyword: 'Contract Automation, Contract Checklist, eSignature',
    pricing_meta_keyword: 'Manage Contracts, Validate Contracts',
    faq_meta_keyword: 'Contract software, Contract Tool',
    contact_meta_keyword: 'Online Contract Management',
    login_meta_keyword: 'Sign contracts online, Manage contracts',
    sign_up_meta_keyword: 'Best Contract Software, Contract Platform',
    careers_meta_keyword: 'Contract Automation Careers, Contract Software Jobs',
    integration_meta_keyword: 'Contract Portal, Contract Cloud Integration',
    term_condition_meta_keyword: 'Contract rules, Contract conditions',
    privacy_policy_meta_keyword: 'Contract Data Privacy, Secure Contract Software',

    home_start_scratch: 'Create a Sleeve from Scratch.',
    home_use_template: 'Create a Sleeve from Pre-made Template.',
    env_envelope_name: 'Enter the Sleeve name.',
    env_sleeve_name: 'Sleeve Name (internal reference only).',
    env_due_date: 'Set Contract Due Date. Collaborators will be reminded before the due date.',
    env_client_message: 'Collaborators can sign and communicate via Client Portal. Customize portal message text as needed.',
    env_save_exit: 'Save & Exit will store your Sleeve in Drafts.',
    env_recipient_detail: 'The collaborator is your client/partner who will sign the contract.',
    env_add_recipient: 'Add collaborators by entering their details.',
    env_subject: 'Email subject line for collaborators (default text can be changed).',
    env_email_text: 'Default email body for collaborators (can be customized).',
    env_add_doc_template: 'Add pre-made contract templates.',
    env_add_document: 'Add specific contract documents for signature.',
    env_add_data_template: 'Add contract-related data from templates.',
    env_add_question: 'Add clauses or required inputs for the contract.',
    env_sms_type: 'Select type of SMS notification for collaborators.',
    env_naming_convention: 'Signed contracts will be saved with this name.',
    env_cloud_sync: 'Connect with Cloud Apps to sync signed contracts.',
    env_send_reminder: 'Send reminders until collaborators sign the contract.',
    env_overdue_reminder: 'After the due date, overdue reminders will be sent.',
    env_password: 'Protect your Sleeve with a password.',
    env_reference: 'Assign a unique reference for internal tracking.',
    env_send: 'Clicking "Send" will email collaborators a unique signing link.',
    env_add_to_template: 'Save this sleeve as a template for reuse.',
    env_view_sleeve: 'View and manage your Sleeve.',
    env_create_another: 'Create another Sleeve.',

    home_text: 'Choose how you want to create and send contracts.',
    notification_sleeve_activity: 'Get notified when collaborators sign or update a contract.',
    preference_sync_cloud: 'Sync Contracts to the Cloud',
    preference_sync_cloud_text: 'Automatically sync all contracts to Cloud storage.',
    preference_default_storage: 'Set Default Cloud Storage',
    preference_default_storage_text: 'Choose default storage for all contracts.',

    google_drive_success: 'Google Drive successfully connected',
    drop_box_success: 'Dropbox successfully connected',
    box_success: 'Box successfully connected',
    oops_message: 'Oops...something went wrong. Please try again.'
};

export const Lang = content;
